import React, { ReactElement, useContext, useEffect } from "react"

import { MappingPriceContext } from "../../../../providers/MappingPricesContext"
import { DataUploadContext } from "../../../../providers/DataUploadContext"

import { requiredFields } from "../../../../constants/prices"

const MappingValidation = (): ReactElement => {
  const { mappingRows, schema } = useContext(MappingPriceContext)
  const { setNewMapping } = useContext(DataUploadContext)

  const checkField = (field: string, commodity?: boolean, unit?: boolean): boolean => {
    return (
      !!mappingRows.find(
        item => item.isValid && (item.type === field || (commodity && item.commodity) || (unit && item.unit)),
      ) || schema[field]
    )
  }

  useEffect(() => {
    if (!mappingRows?.length) return
    const isCompleted = requiredFields.every(item => checkField(item.field, item.commodity, item.unit))
    setNewMapping(prev => (prev ? { ...prev, isCompleted } : null))
  }, [mappingRows, schema])

  return (
    <div className="flex flex-wrap gap-2 bg-white justify-center items-center p-4 border-t-2 border-gray-200 sticky bottom-0 mt-8">
      {requiredFields.map(item => (
        <div
          key={item.field}
          title="Mandatory field"
          className={`inline-flex items-center rounded-md p-1 px-2 text-xs font-bold border-2 border-solid ${
            checkField(item.field, item.commodity, item.unit)
              ? "bg-green-400/10 text-teal-500"
              : "bg-red-400/10 text-red-400"
          }  `}
        >
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  )
}

export default MappingValidation
